import React from "react";

export default function Header({ isData, isPageLoading, data }) {
  const userName = isData && !isPageLoading && data?.billCustomerName ? `Welcome, ${data.billCustomerName}` : "";

  return (
    <>
      <header className="site-header" id="header">
        <div className="site-header-inner">
          <nav className="site-header-nav" aria-label="Application Menu">
            <div className="site-header-logo site-header-logo-container">
              <a className="logo-link" href="https://asce.org" aria-label="ASCE">
                <div className="site-header-logo-img">
                  <span className="sr-text">ASCE logo</span>
                </div>
              </a>
            </div>
            <div className="site-header-name-wrapper">
              <span className="site-header-name">{userName}</span>
            </div>
          </nav>
        </div>
      </header>

      <header className="mobile-header" id="mobile-header">
        <div className="mobile-header-inner">
          <div className="mobile-header-logo">
            <a className="logo-link" href="https://asce.org" aria-label="ASCE">
              <div className="mobile-header-logo-img">
                <span className="sr-text">ASCE logo</span>
              </div>
            </a>
          </div>
          <div className="mobile-header-name-wrapper">
            <span className="mobile-header-name">{userName}</span>
          </div>
        </div>
      </header>
    </>
  );
}
